import * as React from 'react';
import { Route, Routes } from 'react-router-dom';
import { Four04 } from 'gossamer-front-end';
import { PaymentInDisplay } from './PaymentInDisplay';
import { PaymentInSearch } from './PaymentInSearch';
import { PaymentOutDisplay } from './PaymentOutDisplay';
import { PaymentOutSearch } from './PaymentOutSearch';
import { InstitutionPaymentsSummary } from './InstitutionPaymentsSummary';
import { UserPaymentsSummary } from './UserPaymentsSummary';

export const PaymentInRoutes = (): React.JSX.Element => (
  <Routes>
    <Route path="/display/:key" element={<PaymentInDisplay />} />
    <Route path="/search" element={<PaymentInSearch />} />
    <Route path="*" element={<Four04 />} />
  </Routes>
);

export const PaymentOutRoutes = (): React.JSX.Element => (
  <Routes>
    <Route path="/display/:key" element={<PaymentOutDisplay />} />
    <Route path="/search" element={<PaymentOutSearch />} />
    <Route path="*" element={<Four04 />} />
  </Routes>
);

export const PaymentsRoutes = (): React.JSX.Element => (
  <Routes>
    <Route path="/institution-summary" element={<InstitutionPaymentsSummary />} />
    <Route path="/user-summary" element={<UserPaymentsSummary />} />
    <Route path="*" element={<Four04 />} />
  </Routes>
);
